<template>
  <v-dialog
    persistent
    v-model="opened"
    max-width="480px"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card class="content-container">
      <v-card-title class="title pt-2 pb-1">
        {{ $t('selectEntity.selectEntityToView') }}
        <v-spacer />
        <v-btn
          fab
          small
          class="error--text text-none my-0"
          style="margin-right: -5px"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon size="25">clear</v-icon>
        </v-btn>
      </v-card-title>

      <template v-if="viewableEntities.length === 0">
        <v-layout class="pa-3 body-1 text-xs-left">
          <span style="font-size: 15px"
            >This account does not have active entities to view. Please contact
            your CPA.</span
          >
        </v-layout>
      </template>

      <template v-else>
        <v-alert
          outline
          color="primary"
          :value="true"
          class="text-xs-left"
          icon="info"
        >
          {{ $t('selectEntity.selectEntityToViewMessage') }}
        </v-alert>

        <v-list class="mt-2" one-line>
          <v-list-tile
            v-for="entity in viewableEntities"
            :key="entity.id"
            @click="$emit('selectEntity', entity.id)"
            avatar
            class="py-1"
          >
            <v-list-tile-content>
              <v-list-tile-title
                v-text="entity.tax_return_name"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-text="entity.entity_type"
              ></v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SelectEntityDialog',
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('companies', ['companies']),
    ...mapGetters({
      currentUser: 'user',
    }),

    viewableEntities() {
      return this.companies.filter(c => !c.inactive);
    },
  },
  methods: {
    isPersonal(entity_type) {
      return entity_type === 'Individual';
    },
  },
};
</script>

<style scoped lang="postcss">
.v-toolbar {
  background-color: #46535c;
}

.title {
  font-weight: 700;
}
</style>
